/**
 * GlobalLoader component - displays a full-screen loading spinner
 * Used as a fallback for route transitions and Suspense boundaries
 */
export const GlobalLoader = () => (
  <div className="h-screen flex items-center justify-center">
    <div className="w-16 h-16 border-4 border-t-orange-500 border-r-transparent border-b-orange-500 border-l-transparent rounded-full animate-spin"></div>
  </div>
);

export default GlobalLoader;
